import React from 'react';
import { useNavigate } from 'react-router-dom';
import DeudaPresencialPanel from '../components/admin/DeudaPresencialPanel';

const CobrosPendientesPage = () => {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f8fafc" }}>
      {/* Header */}
      <div style={{ backgroundColor: "#fff", borderBottom: "1px solid #e2e8f0", padding: "12px 24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <button onClick={() => navigate("/admin")}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: "14px", color: "#3b82f6" }}>
            ← Panel Admin
          </button>
          <h1 style={{ margin: 0, fontSize: "18px", fontWeight: 700, color: "#1e293b" }}>Cobros Pendientes</h1>
        </div>
      </div>

      {/* Content */}
      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "24px" }}>
        <DeudaPresencialPanel />
      </div>
    </div>
  );
};

export default CobrosPendientesPage;
